import React, { useState, useEffect } from "react";
import SwitchConInput from "./fields/SwitchConInput";

const Impianti = (props) => {
  const [impianti, setImpianti] = useState(
    props.preventivo.impianti || {

      title: "Impianti",
      descr: "Il prezzo comprende i materiali per la realizzazione",

      // impiantoElettrico
      impiantoElettrico: {
        tipologia: "SwitchConInput",
        titolo: "Realizzazione impianto elettrico",
        descrizione:
          'Pianificazione e progettazione, preparazione del sito, installazione dei cavi elettrici. montaggio degli apparecchi elettrici, collaudo e cablaggio',
        valore: false,
        descrizioneQuantita: "Numero punti luce",
        descQuantita: "num",
        quantita: 0,
        prezzo: 60,
        extra: {
          descrizione: 'Assistenza impianto elettrico',
          //percentuale: 50
        }
      },
      // impiantoIdraulico
      impiantoIdraulico: {
        tipologia: "SwitchConInput",
        titolo: "Realizzazione impianto idraulico",
        descrizione:
          "Pianificazione e progettazione, preparazione del sito, installazione delle tubazioni, installazione dei dispositivi di controllo e regolazione,collegamento alla rete idrica esterna, verifica e collaudo,  non comprende installazione sanitari previsto allo step installazioni ",
        valore: false,
        descrizioneQuantita: "Numero punti acqua",
        descQuantita: "num",
        quantita: 0,
        prezzo: 220,
        extra: {
          descrizione: 'Assistenza impianto idraulico',
          //percentuale: 50
        }
      },
      // impiantoAriaCondizionata
      impiantoAriaCondizionata: {
        tipologia: "SwitchConInput",
        titolo: "Realizzazione impianto aria condizionata",
        descrizione: `Valutazione delle esigenze, identificazione sito di installazione, installazione dell'unità esterna, installazione delle unità interne / split,collegamento delle linee refrigeranti, installazione dlele canalizzazioni e dei condotti dell'aria, collegamento elettrico, avviamento e collaudo. `,
        valore: false,
        descrizioneQuantita: "Numero split",
        descQuantita: "num",
        quantita: 0,
        prezzo: 300,
      }
    }// fine json
  ); // fine state


  useEffect(() => {
    props.onChange(impianti);
  }, [impianti]);

  // divisore
  const divider = (
    <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
  );

  return (
    <>
      <div className="surface-ground px-1 py-1 md:px-4 md:py-4">
        <div className="text-900 font-medium text-900 text-xl mb-2">
          {impianti.title}
        </div>
        <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">
        {impianti.descr}
        </p>
        <div className="surface-card p-4 shadow-2 border-round">
          <div className="grid formgrid p-fluid">
            <SwitchConInput
              field={impianti.impiantoElettrico}
              onChange={(data) => {
                setImpianti({ ...impianti, impiantoElettrico: data });
              }}
            ></SwitchConInput>
            {divider}
            <SwitchConInput
              field={impianti.impiantoIdraulico}
              onChange={(data) => {
                setImpianti({ ...impianti, impiantoIdraulico: data });
              }}
            ></SwitchConInput>
            {divider}
            <SwitchConInput
              field={impianti.impiantoAriaCondizionata}
              onChange={(data) => {
                setImpianti({ ...impianti, impiantoAriaCondizionata: data });
              }}
            ></SwitchConInput>
            {divider}
          </div>
        </div>
      </div>
    </>
  );
};
export default Impianti;
